import axios from 'axios';
import { apiUrl } from "../constans";
const auth = {
    namespaced: true,
    state: {
        isAuthenticated: localStorage.getItem('is_authenticated'),
        accessToken: localStorage.getItem("access_token") || null,
        user: null,
        expiresIn: 0,
        refreshToken: '',
        tokenType: '',
    },

    mutations: {
        setAccessToken(state, accessToken) {
            localStorage.setItem('access_token', accessToken);
            state.accessToken = accessToken;
        },
        setExpiresIn(state, expiresIn) {
            localStorage.setItem('expires_in', expiresIn);
            state.expiresIn = expiresIn;
        },

        setRefreshToken(state, refreshToken) {
            state.refreshToken = refreshToken;
        },
        setTokenType(state, tokenType) {
            state.tokenType = tokenType;
        },
        setIsAuthenticated(state, isAuthenticated) {
            localStorage.setItem('is_authenticated', isAuthenticated);
            state.isAuthenticated = isAuthenticated;
        }
    },

    getters: {
        isAuthenticated(state) {
            return state.isAuthenticated;
        },
        getAccessToken(state) {
            return state.accessToken;
        },

        getExpiresIn: () => localStorage.getItem('expires_in')

    },

    actions: {
        login({ commit }, { email, password }) {
            // Simulación de una llamada asíncrona a la API de autenticación
            return new Promise((resolve, reject) => {

                axios.post(`${apiUrl}/login`, { email, password })
                    .then(response => {
                        const token = response.data.token;
                        commit('setAccessToken', token.access_token);
                        commit('setExpiresIn', token.expires_in);
                        commit('setRefreshToken', token.refresh_token);
                        commit('setTokenType', token.token_type);
                        commit('setIsAuthenticated', true);

                        resolve("Inicio de session exitoso");
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario
            });

        },


        async logout({ commit }) {
            try {
                commit('setAccessToken', null);
                commit('setExpiresIn', null);
                commit('setRefreshToken', null);
                commit('setTokenType', null);

                localStorage.removeItem('access_token'); // Suponiendo que tienes un token almacenado en localStorage
                localStorage.removeItem("expires_in");
                localStorage.removeItem("user");

                commit('setIsAuthenticated', false);

                return true
            } catch (error) {
                return Promise.reject(error)
            }


        }
    }
}

export default auth;
